<div class="flex flex-row justify-start items-center gap-x-4">
  <ng-content></ng-content>
  <ul
    class="list-none flex flex-row flex-wrap justify-start mb-2 items-center md:gap-x-4 gap-x-2"
    [testId]="testIds.GRID_BREADCRUMB"
  >
    <li
      class="p-0 m-0 flex flex-row justify-center items-center gap-x-4"
      [testId]="testIds.GRID_BREADCRUMB_ITEM"
    >
      <a (click)="breadcrumbSelected(null)"> All Categories </a>
      <mat-icon *ngIf="!atTopLevel"> chevron_right</mat-icon>
    </li>
    <ng-container *ngFor="let crumb of breadcrumbs$ | async; let last = last">
      <li
        [testId]="testIds.GRID_BREADCRUMB_ITEM"
        class="p-0 m-0 flex flex-row justify-center items-center gap-x-4"
        *ngIf="!last"
      >
        <a (click)="breadcrumbSelected(crumb)">
          {{ crumb.label }}
        </a>
        <mat-icon> chevron_right</mat-icon>
      </li>
      <li
        [testId]="testIds.GRID_BREADCRUMB_ITEM"
        class="p-0 m-0 flex flex-row justify-center items-center gap-x-4"
        *ngIf="last"
      >
        {{ crumb.label }}
      </li>
    </ng-container>
  </ul>
</div>
